import { Seo } from '@common/components';
import Styles from './Styles.module.scss';
import { DistHead } from './components';
import { CLI, PyLib } from './sections';

export default function Distribution() {
    return (
        <>
            <Seo
                title="ModelPark CLI - Expose Local ML Apps"
                description="Install the ModelPark CLI to expose your local ML applications to the internet. Supports Gradio, Streamlit, FastAPI, and more."
                keywords="modelpark, cli, tunnel, localhost, ngrok, ml deployment, gradio, streamlit, fastapi"
                name="ModelPark"
            />
            <div className={Styles.DistContainer}>
                <DistHead />

                <CLI />

                <PyLib />
            </div>
        </>
    );
}
